export default "__VITE_ASSET__C9xC_mLT__"